var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{staticClass:"text-center pa-8",attrs:{"outlined":""}},[_c('subtitle',[_vm._t("default")],2),(_vm.button)?_c('PrimaryButton',_vm._g({staticClass:"mb-3",attrs:{"disabled":_vm.disabled,"loading":_vm.loading}},_vm.$listeners),[_vm._v(_vm._s(_vm.button))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }